import { useState } from 'react';
import { useLoaderData, useParams } from 'react-router';
import { Card, CardBody, Type } from '@mindstep-axa-dmhi/dmhi-frontend-components';
import { Button, Link } from '../../../../components';
import { ScreeningConfig } from '../../../../services/config';
import useTranslate from '../../../../hooks/use-translate';
import getPath from '../../../../utils/path';
import LanguagesModal from '../languages-modal';

import Logo from '../../../../assets/mind-health-self-check.png';
import ImgIconFlagBE from '../../../../assets/icon-flag-be.png';
import ImgIconGlobal from '../../../../assets/icon-global.png';

const languages = [
  {
    name: 'English',
    icon: ImgIconGlobal,
    code: 'en',
    url: '/',
  },
  {
    name: 'Nederlands',
    icon: ImgIconFlagBE,
    code: 'nl-BE',
    url: '/nl-BE',
  },
  {
    name: 'Français',
    icon: ImgIconFlagBE,
    code: 'fr-BE',
    url: '/fr-BE',
  },
];

function LandingLocal() {
  const { screenings } = useLoaderData() ?? {};
  const { t, i18n } = useTranslate();
  const { lang } = useParams();
  const [languagesModalIsOpen, setLanguagesModalIsOpen] = useState(false);

  const toggleLanguagesModal = () => {
    setLanguagesModalIsOpen((isOpen) => !isOpen);
  };

  const actions = (
    <div className="flex gap-4 lg:flex-row lg:gap-8">
      <Button
        component={Link}
        to={getPath(lang, '/history')}
        variant="primary"
        id="history"
      >
        {t('welcome.history')}
      </Button>
      <Button
        type="button"
        variant="outline-primary"
        onClick={toggleLanguagesModal}
        id="change_language"
      >
        {t('welcome.change_language')}
      </Button>
    </div>
  );

  return (
    <div className="flex flex-1 flex-col lg:flex-row relative">
      <div className="container mx-auto px-4 mt-4 flex flex-col lg:flex-row items-center gap-8 md:gap-12 md:mt-12 lg:my-28 lg:px-12">
        <div className="flex flex-col justify-center items-center lg:items-start text-center lg:text-left gap-8 lg:gap-24 px-4 lg:px-12">
          <img src={Logo} alt="Mind Health Self Check logo" className="max-w-[316px]" />
          <Type variant="h1" className="lg:text-3xl">{t('welcome.title')}</Type>
          <div className="hidden lg:block">
            {actions}
          </div>
        </div>
        <LanguagesModal
          languages={languages}
          active={i18n.language}
          isOpen={languagesModalIsOpen}
          toggle={toggleLanguagesModal}
        />
        <div className="flex flex-col gap-6 mx-auto lg:gap-12">
          {screenings?.map?.((screening) => {
            const config = ScreeningConfig[screening.id];

            return (
              <Card key={screening.id}>
                <CardBody className="flex gap-4">
                  <div
                    className="shrink-0 w-[67px] h-[67px] lg:w-[123px] lg:h-[123px] bg-[image:var(--bg)] bg-cover bg-center rounded-lg"
                    style={{
                      '--bg': `url('${config.icon}')`,
                    }}
                  />
                  <div className="flex flex-col gap-2">
                    <Type variant="h2">{t(config.title)}</Type>
                    <p className="lg:text-lg">{t(config.description)}</p>
                    <Link to={getPath(lang, `/assessment/${screening.id}`)} className="mt-2 lg:mt-4 text-axa-blue-100 lg:text-lg font-semibold">
                      {t(config.cta)}
                    </Link>
                  </div>
                </CardBody>
              </Card>
            );
          })}
        </div>
        <div className="lg:hidden mt-8">
          {actions}
        </div>
      </div>
    </div>
  );
}

export default LandingLocal;
